// extracted by mini-css-extract-plugin
export default {"root":"n5jfHJ7F","icon":"iRmhYLM9","text":"vY1KSQJV"};